import { DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-percentage-cell' },
  imports: [DecimalPipe],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `@if (this.value !== null && this.value !== undefined) {
    {{ this.value | number: '1.0-2' }} %
  }`,
})
export class GridPercentageCellComponent extends AbstractCellComponent<any, number> {}
